import orders from "@/services/orders";

const initialState = () => ({
  // 1 - Loading, 2 - Successful, 3 - unsuccesful, 4 - uncaught error

  // placing an order
  placeOrderStatus: 0,
  placeOrderMessage: null,
  placedOrderID: null,

  // getting orders
  getOrdersStatus: 0,
  getOrdersMessage: null,
  orders: null,
  ordersTotal: null,
  ordersPages: null,

  // getting a single order (by id)
  getAnOrdersStatus: 0,
  getAnOrdersMessage: null,
  order: null,

  // getting order items of an order
  getOrderItemsStatus: 0,
  getOrderItemsMessage: null,
  orderItems: null,

  // getting an order item
  getAnOrderItemStatus: 0,
  getAnOrderItemMessage: null,
  orderItem: null,

});


const state = initialState();

const getters = {
  // placing an order
  placeOrderStatus: state => state.placeOrderStatus,
  placeOrderMessage: state => state.placeOrderMessage,
  placedOrderID: state => state.placedOrderID,

  // getting orders
  getOrdersStatus: state => state.getOrdersStatus,
  getOrdersMessage: state => state.getOrdersMessage,
  orders: state => state.orders,
  ordersTotal: state => state.ordersTotal,
  ordersPages: state => state.ordersPages,

  // getting a single order (by id)
  getOrderStatus: state => state.getAnOrdersStatus,
  getOrderMessage: state => state.getAnOrdersMessage,
  order: state => state.order,

  // getting order items of an order
  getOrderItemsStatus: state => state.getOrderItemsStatus,
  getOrderItemsMessage: state => state.getOrderItemsMessage,
  orderItems: state => state.orderItems,

  // getting an order item
  getAnOrderItemStatus: state => state.getAnOrderItemStatus,
  getAnOrderItemMessage: state => state.getAnOrderItemMessage,
  orderItem: state => state.orderItem,
};

const actions = {
  placeOrder: async ({ commit }, payload) => {
    try {
      commit("placeOrderRequest");
      const response = await orders.place(payload);
      window.r = response
      commit("placeOrderSuccess", response.data)
    } catch (error) {
      commit("placeOrderError", error);
    }
  },
  getOrders: async ({ commit }) => {
    try {
      commit("getOrdersRequest");
      const response = await orders.getAll();
      commit("getOrdersSuccess", response.data);
    } catch (error) {
      commit("getOrdersError", error);
    }
  },
  getOrder: async ({ commit }, orderId) => {
    try {
      commit("getAnOrderRequest");
      const response = await orders.getOne(orderId);
      commit("getAnOrderSuccess", response.data);
    } catch (error) {
      commit("getAnOrderError", error);
    }
  },
  getOrderItems: async ({ commit }, orderId) => {
    try {
      commit("getOrderItemsRequest");
      const response = await orders.getItems(orderId);
      commit("getOrderItemsSuccess", response.data);
    } catch (error) {
      commit("getOrderItemsError", error);
    }
  },
  getAnOrderItem: async ({ commit }, { orderId, orderItemId }) => {
    try {
      commit("getAnOrderItemRequest");
      const response = await orders.getAnItem(orderId, orderItemId);
      commit("getAnOrderItemSuccess", response.data);
    } catch (error) {
      commit("getAnOrderItemError", error);
    }
  },

};

const mutations = {
  // placing an order
  placeOrderRequest: state => state.placeOrderStatus = 1,
  placeOrderSuccess(state, { message, data }) {
    state.placedOrderID = data.orderId
    state.placeOrderStatus = 2;
    state.placeOrderMessage = message;
  },
  placeOrderError(state, error) {
    window.e = error
    console.log('Error: ', error.response)
    state.placeOrderStatus = 3;
    state.placeOrderMessage = error.response.data.message;
  },

  // getting orders
  getOrdersRequest: state => state.getOrdersStatus = 1,
  getOrdersSuccess(state, { message, data }) {
    state.orders = data.userOrders;
    state.ordersTotal = data.totalCount;
    state.ordersPages = data.totalPages;

    state.getOrdersStatus = 2;
    state.getOrdersMessage = message;
  },
  getOrdersError(state, error) {
    state.getOrdersStatus = 3;
    state.getOrdersMessage = error.response.data.message;
  },

  // getting a single order (by id)
  getAnOrderRequest: state => state.getAnOrdersStatus = 1,
  getAnOrderSuccess(state, { message, data }) {
    state.order = data;
    state.getAnOrdersStatus = 2;
    state.getAnOrdersMessage = message;
  },
  getAnOrderError(state, error) {
    state.getAnOrdersStatus = 3;
    state.getAnOrdersMessage = error.response.data.message;
  },

  // getting order items of an order
  getOrderItemsRequest: state => state.getOrderItemsStatus = 1,
  getOrderItemsSuccess(state, { message, data }) {
    state.orderItems = data;
    state.getOrderItemsStatus = 2;
    state.getOrderItemsMessage = message;
  },
  getOrderItemsError(state, error) {
    state.getOrderItemsStatus = 3;
    state.getOrderItemsMessage = error.response.data.message;
  },

  // getting an order item
  getAnOrderItemRequest: state => state.getAnOrderItemStatus = 1,
  getAnOrderItemSuccess(state, { message, data }) {
    state.orderItem = data;
    state.getAnOrderItemStatus = 2;
    state.getAnOrderItemMessage = message;
  },
  getAnOrderItemError(state, error) {
    state.getAnOrderItemStatus = 3;
    state.getAnOrderItemMessage = error.response.data.message;
  },


  // when payment page is called from other pages
  setPlacedOrderID: (state, orderID) => state.placedOrderID = orderID,

  reset(state) {
    const newState = initialState()
    Object.keys(newState).forEach(key => {
      state[key] = newState[key]
    })
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}